import React from "react";
import { AppProvider } from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { Link } from "react-router-dom";
import { ToastComponent } from "src/components/ToastComponent";
import { ModalComponent } from "src/components/ModalComponent";
import { Toast } from "src/hooks/toast";
import { Modal } from "src/hooks/modal";

export function PolarisProvider(props: React.PropsWithChildren<{}>) {
  return (
    <AppProvider
      i18n={en}
      features={{ polarisSummerEditions2023: true, polarisSummerEditions2023ShadowBevelOptOut: false }}
      linkComponent={({ children, url, ...rest }: { children?: React.ReactNode; url: string }) => {
        return (
          <Link to={url} {...rest}>
            {children}
          </Link>
        );
      }}
    >
      {/* <Frame logo={{ width: 124, contextualSaveBarSource: "/seller.svg" }}> */}
      <ToastComponent ref={(t) => Toast.setToast(t)} />
      <ModalComponent ref={(t) => Modal.setModal(t)} />
      {props.children}
      {/* </Frame> */}
    </AppProvider>
  );
}
